export default {
  group: {
    rechargeBehavior: 'Recharge Behavior Tags',
    withdrawBehavior: 'Withdraw Behavior Tags',
    betBehavior: 'Bet Behavior Tags',
    gamePreference: 'Game Preference Tags',
    lifecycle: 'Lifecycle Tags',
    userValue: 'User Value Tags',
  },
  field: {
    tagName: 'Tag',
    hitCount: 'User Count',
    hitDescription: 'Hit Description',
    operation: 'Operation',
    refreshDays: 'Refresh Period',
    lastUpdateTime: 'Last Updated',
    nextUpdateTime: 'Next Auto Update',
    refreshCycle: 'Interval',
    configSetting: 'Hit Settings',
  },
  action: {
    enable: 'Enable',
    disable: 'Disable',
    setting: 'Settings',
    save: 'Save',
    back: 'Back',
    manualUpdate: 'Manual Update',
    updating: 'Updating...',
    confirm: 'OK',
  },
  unit: {
    days: 'Days',
  },
  connector: {
    and: 'and ≤',
  },
  pageTitle: 'Auto Tag Settings',
  settingTitle: ' Settings',
  noAutoTags: 'No auto tags',
  message: {
    statusUpdateSuccess: 'Status updated successfully',
    statusUpdateFailed: 'Failed to update status',
    saveSuccess: 'Saved successfully',
    saveFailed: 'Failed to save',
    configRequired: 'All fields are required, please complete the configuration',
    manualUpdateSuccess: 'Manual update triggered, calculating in background. Please refresh later.',
    manualUpdateFailed: 'Manual update failed',
    groupCalculating: 'This tag group is being updated automatically, please try again later.',
  },
  configRule: {
    integerOnly: 'Positive integers only',
    amountUnit: 'Amount unit is consistent with platform recharge currency',
    emptyDisabled: 'A tag with an empty threshold does not participate in matching for this currency',
  },
  tag: {
    FIRST_RECHARGE: 'First Deposit User',
    NO_RECHARGE: 'No Recharge User',
    RECHARGE_FREQ_LOW: 'Low Recharge Frequency',
    RECHARGE_FREQ_MID: 'Medium Recharge Frequency',
    RECHARGE_FREQ_HIGH: 'High Recharge Frequency',
    RECHARGE_AMT_LOW: 'Low Recharge Amount',
    RECHARGE_AMT_MID: 'Medium Recharge Amount',
    RECHARGE_AMT_HIGH: 'High Recharge Amount',
    NO_WITHDRAW: 'No Withdraw User',
    WITHDRAW_FREQ_LOW: 'Low Withdraw Frequency',
    WITHDRAW_FREQ_MID: 'Medium Withdraw Frequency',
    WITHDRAW_FREQ_HIGH: 'High Withdraw Frequency',
    WITHDRAW_AMT_LOW: 'Low Withdraw Amount',
    WITHDRAW_AMT_MID: 'Medium Withdraw Amount',
    WITHDRAW_AMT_HIGH: 'High Withdraw Amount',
    NO_BET: 'No Bet User',
    BET_FREQ_LOW: 'Low Bet Frequency',
    BET_FREQ_MID: 'Medium Bet Frequency',
    BET_FREQ_HIGH: 'High Bet Frequency',
    BET_AMT_LOW: 'Low Bet Amount',
    BET_AMT_MID: 'Medium Bet Amount',
    BET_AMT_HIGH: 'High Bet Amount',
    PREFER_LIVE: 'Prefer Live Casino',
    PREFER_SLOT: 'Prefer Slots',
    PREFER_SPORT: 'Prefer Sports',
    PREFER_CHESS: 'Prefer Board Games',
    ACTIVE_RETAINED: 'Active Retained User',
    ACTIVE_NO_DEPOSIT: 'Active No Deposit User',
    RETURN_NO_RECHARGE: 'Returned No Recharge User',
    CHURN_RISK: 'Churn Risk User',
    CHURNED: 'Churned User',
    NET_LOSS_HIGH: 'High Net Loss User',
    NET_LOSS_MID: 'Medium Net Loss User',
    NET_LOSS_LOW: 'Low Net Loss User',
    NET_WIN_HIGH: 'High Net Win User',
    NET_WIN_MID: 'Medium Net Win User',
    NET_WIN_LOW: 'Low Net Win User',
  },
  hitDesc: {
    FIRST_RECHARGE: 'First recharge = 1',
    NO_RECHARGE: 'Total recharge count = 0',
    RECHARGE_FREQ_LOW: 'Total recharge count ≤ X',
    RECHARGE_FREQ_MID: 'Total recharge count ≥ X and ≤ X',
    RECHARGE_FREQ_HIGH: 'Total recharge count ≥ X',
    RECHARGE_AMT_LOW: 'Total recharge amount ≤ X',
    RECHARGE_AMT_MID: 'Total recharge amount ≥ X and ≤ X',
    RECHARGE_AMT_HIGH: 'Total recharge amount ≥ X',
    NO_WITHDRAW: 'Total withdraw count = 0',
    WITHDRAW_FREQ_LOW: 'Total withdraw count ≤ X',
    WITHDRAW_FREQ_MID: 'Total withdraw count ≥ X and ≤ X',
    WITHDRAW_FREQ_HIGH: 'Total withdraw count ≥ X',
    WITHDRAW_AMT_LOW: 'Total withdraw amount ≤ X',
    WITHDRAW_AMT_MID: 'Total withdraw amount ≥ X and ≤ X',
    WITHDRAW_AMT_HIGH: 'Total withdraw amount ≥ X',
    NO_BET: 'Total bet count = 0',
    BET_FREQ_LOW: 'Total bet count ≤ X',
    BET_FREQ_MID: 'Total bet count ≥ X and ≤ X',
    BET_FREQ_HIGH: 'Total bet count ≥ X',
    BET_AMT_LOW: 'Total bet amount ≤ X',
    BET_AMT_MID: 'Total bet amount ≥ X and ≤ X',
    BET_AMT_HIGH: 'Total bet amount ≥ X',
    PREFER_LIVE: 'Live casino bet ratio ≥ 50%',
    PREFER_SLOT: 'Slots bet ratio ≥ 50%',
    PREFER_SPORT: 'Sports bet ratio ≥ 50%',
    PREFER_CHESS: 'Board games bet ratio ≥ 50%',
    ACTIVE_RETAINED: '≤ 7 days with bets and deposits (not first deposit)',
    ACTIVE_NO_DEPOSIT: '≤ 7 days with bets and no deposits',
    RETURN_NO_RECHARGE: '≤ 7 days with bets, no deposits, last deposit ∈ [15 days ago, 30 days ago]',
    CHURN_RISK: '7 consecutive days no login/bet, had deposits within 7-15 days',
    CHURNED: '15 consecutive days no login/bet, had deposits >30 days ago',
    NET_LOSS_HIGH: 'Net loss ≥ X',
    NET_LOSS_MID: 'Net loss ≥ X and ≤ X',
    NET_LOSS_LOW: 'Net loss ≤ X',
    NET_WIN_HIGH: 'Net win ≥ X',
    NET_WIN_MID: 'Net win ≥ X and ≤ X',
    NET_WIN_LOW: 'Net win ≤ X',
  },
  configLabel: {
    RECHARGE_FREQ_LOW: 'Total recharge count ≤',
    RECHARGE_FREQ_MID: 'Total recharge count ≥',
    RECHARGE_FREQ_HIGH: 'Total recharge count ≥',
    RECHARGE_AMT_LOW: 'Total recharge amount ≤',
    RECHARGE_AMT_MID: 'Total recharge amount ≥',
    RECHARGE_AMT_HIGH: 'Total recharge amount ≥',
    WITHDRAW_FREQ_LOW: 'Total withdraw count ≤',
    WITHDRAW_FREQ_MID: 'Total withdraw count ≥',
    WITHDRAW_FREQ_HIGH: 'Total withdraw count ≥',
    WITHDRAW_AMT_LOW: 'Total withdraw amount ≤',
    WITHDRAW_AMT_MID: 'Total withdraw amount ≥',
    WITHDRAW_AMT_HIGH: 'Total withdraw amount ≥',
    BET_FREQ_LOW: 'Total bet count ≤',
    BET_FREQ_MID: 'Total bet count ≥',
    BET_FREQ_HIGH: 'Total bet count ≥',
    BET_AMT_LOW: 'Total bet amount ≤',
    BET_AMT_MID: 'Total bet amount ≥',
    BET_AMT_HIGH: 'Total bet amount ≥',
    NET_LOSS_HIGH: 'Net loss ≥',
    NET_LOSS_MID: 'Net loss ≥',
    NET_LOSS_LOW: 'Net loss ≤',
    NET_WIN_HIGH: 'Net win ≥',
    NET_WIN_MID: 'Net win ≥',
    NET_WIN_LOW: 'Net win ≤',
  },
}
